
import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MenuItem } from '../../sidebar/sidebar-menu';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-menu-filter-dialog',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule],
  templateUrl: './menu-filter-dialog.component.html',
  styleUrl: './menu-filter-dialog.component.scss'
})
export class MenuSearchDialogComponent {
  search = '';
  filteredMenu: MenuItem[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { menuItems: MenuItem[] },
    private dialogRef: MatDialogRef<MenuSearchDialogComponent>
  ) {

  }




  filterMenu(value: string) {
    this.search = value.trim().toLowerCase();

    if (!this.search) {
      this.filteredMenu = [];
      return;
    }

    this.filteredMenu = this.data.menuItems
      .map(item => {
        const parentMatches = item.title.toLowerCase().includes(this.search);

        // If item has children → filter them
        if (item.subItems?.length) {
          const matchingSubItems = item.subItems.filter(sub =>
            sub.title.toLowerCase().includes(this.search)
          );

          // Only keep this parent if:
          // 1. A child matches OR
          // 2. Parent itself matches
          if (matchingSubItems.length || parentMatches) {
            return {
              ...item,
              isExpanded: matchingSubItems.length > 0,
              subItems: matchingSubItems
            };
          }

          return null; // hide parent with no matching children
        }

        // If NO children → it's a direct route item
        // Keep it if parent title matches
        if (parentMatches) {
          return { ...item };
        }

        return null;
      })
      .filter(Boolean) as MenuItem[];

  }

  onParentClick(item: MenuItem) {
    // If it has children → expand/collapse
    if (item.subItems?.length) {
      item.isExpanded = !item.isExpanded;
      return;
    }
    console.log('Item: ', item)
    console.log('Route: ', item.routerLink)
    // If no children → navigate directly
    if (item.routerLink) {
      this.navigate(item.routerLink);
    }
  }

  navigate(route: string) {
    this.dialogRef.close(route);
  }
  close() {
    this.dialogRef.close();
  }
}
